import React from 'react';
import { __ } from '../../../../utils/translation-service';
import { PhoneIcon } from '../../header/header-mobile-old/Icons/PhoneIcon';
import { EnvelopeIcon } from '../../header/header-mobile-old/Icons/EnvelopeIcon';
import { Link } from '../../header/header-mobile-old/Link';

const style: any = {
    wrapper: {
        background: '#e6e6e6',
        border: 0,
        padding: '15px 15px 17px 15px',
        color: '#2a2a2a',
        fontFamily: 'Arial, Helvetica, sans-serif',
    },
    heading: {
        fontSize: '20px',
        textAlign: 'center',
        fontWeight: 'bold',
        margin: 0,
        marginBottom: 10,
        color: '#2a2a2a',
    },
    contactWrapper: {
        display: 'flex',
        justifyContent: 'space-around',
        color: '#2a2a2a',
    },
    text: {
        fontWeight: 'bold',
        fontSize: 16,
        maxWidth: 90,
        color: '#2a2a2a',
    },
    iconWithText: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0 3px',
        color: '#2a2a2a',
    },
    iconBorder: {
        borderRadius: '50%',
        border: '1px solid black',
        padding: 8,
        fontSize: 0,
        marginRight: 9,
        color: '#2a2a2a',
    },
};

interface IProps {
    phoneNumber: string;
}

export function ContactUs(props: IProps) {
    const TrackableLinkCallUs = Link;
    const TrackableLinkWriteUs = Link;
    return (
        <div style={style.wrapper}>
            <p style={style.heading}>{__('getInContactWithUs')}</p>
            <div style={style.contactWrapper}>
                <TrackableLinkCallUs
                    style={style.iconWithText}
                    href={`tel:${
                        props.phoneNumber ? props.phoneNumber : '<r hidden>phonelead</r>'
                    }`}
                >
                    <div style={style.iconBorder}>
                        {/* added empty object to fix missing values in type  */}
                        <PhoneIcon width={20} height={20} {...({} as any)} />
                    </div>
                    <span style={style.text}>{__('callUs')}</span>
                </TrackableLinkCallUs>
                <TrackableLinkWriteUs style={style.iconWithText} href={`mailto:${__('infoEmail')}`}>
                    <div style={style.iconBorder}>
                        {/* added empty object to fix missing values in type  */}
                        <EnvelopeIcon width={20} height={20} {...({} as any)} />
                    </div>
                    <span style={style.text}>{__('writeUs')}</span>
                </TrackableLinkWriteUs>
            </div>
        </div>
    );
}
